import { BaseService } from './base';
import { ChargeModel } from '../models/chargeModel';

export class ChargeModelService extends BaseService<ChargeModel> {
  override model = ChargeModel;
  override modelName = 'chargeModel';
  override modelLabel = 'Charge Model';
}
